import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function TabletPreviewPanel() {
  return (
    <Box>
      <Typography sx={{ mb: 2 }}>
        Tablet mode shows a single active question with emoji options and an optional text feedback field.
      </Typography>
      <Button
        variant={"contained"}
        className={"text-capitalize"}
        onClick={() => window.open("/feedback-tablet", "_blank")}
      >
        Open Tablet Mode
      </Button>
    </Box>
  );
}
